import { AbstractAccountDataCommand } from "./abstractAccountDataCommand";
import { KeyValue } from "../../responses";

export class CurrentUserCommand extends AbstractAccountDataCommand {
  get?: boolean;
  updateUser?: KeyValue<string, string>[];
  updateSettings?: KeyValue<string, string>[];
}